'use client';

import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

/**
 * 初始化 Capacitor StatusBar
 * 在原生平台（Android/iOS）上设置状态栏策略，避免顶部导航被状态栏/挖孔区域遮挡。
 *
 * 说明：
 * - Android：overlay=false（让 WebView 从状态栏下方开始布局，更稳）
 * - iOS/其它：overlay=true（保持沉浸式体验）
 */
export function StatusBarInit() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const initStatusBar = async () => {
      try {
        const { StatusBar, Style } = await import('@capacitor/status-bar');

        const platform = Capacitor.getPlatform();
        const overlay = platform !== 'android';
        await StatusBar.setOverlaysWebView({ overlay });

        // 白底用 Dark，深色背景用 Light
        await StatusBar.setStyle({ style: Style.Dark });

        // 可选：设置状态栏背景色（Android）
        await StatusBar.setBackgroundColor({ color: '#ffffff' });

        console.log('[StatusBar] initialized:', { platform, overlay });
      } catch (error) {
        console.warn('[StatusBar] Failed to initialize StatusBar:', error);
      }
    };

    initStatusBar();
  }, []);

  return null;
}

